import React from "react";
import { useInitialData } from "../../services/localStorageContext";
import WebSocketAreas from "./WebSocketAreas";
import MqttAreas from "./MqttAreas";
import { Card } from "@mui/material";
import VideoLiveStreamCard from "./VideoLiveStreamCard";

const SensorCard = React.memo(({ broker, sensor }) => {
    // console.log("Render: SensorCard!");
    // console.log("SensorCard recieved Broker: ", broker, " with sensor: ", sensor);
    // const theme = useTheme();

    const { getSensorDataSensorCard } = useInitialData();
    const sensorData = getSensorDataSensorCard({ broker: broker, sensor: sensor });

    return (
        <div>
            <Card
                variant="outlined"
                sx={{ margin: '20px', border: 1, backgroundColor: '#7a7a7a' }}
                key={sensor + "_Card"}>
                {/* Centered Sensor Name */}
                <h2 style={{ margin: 10, textAlign: 'center', color: 'black' }}>
                    {sensor}
                </h2>
                {/* {sensorData.mqtt_data &&
                    <MqttAreas
                        key={`Mqtt-${broker}-${sensor}_Area`}
                        broker={broker}
                        sensor={sensor} />
                } */}

                {/* {sensorData.live_stream &&
                    <VideoLiveStreamCard source={sensorData.live_stream} />
                } */}

                {/* Render WebSocketAreas as a List cause here are multiple socket_Url's possible */}
                {sensorData.socket_data &&
                    sensorData.socket_data.map((area) => (
                        <WebSocketAreas
                            key={`WebSocket-${broker}-${sensor}-${area}_Area`}
                            broker={broker}
                            sensor={sensor}
                            area={area} />
                    ))
                }
            </Card>
        </div>
    );
});

export default SensorCard;